import { useParams } from "react-router-dom";
import Select from "react-select";
import RichTextEditor from "../../../components/RichTextEditor";
import tools from "../../../utils/tools";

const Basic = ({ form, setForm, categories, tags, brands, cars }) => {
  const { id: paramId } = useParams();
  return (
    <div className="AddInfoContainer">
      <label>چینش</label>
      <input
        className="persianName"
        defaultValue={form?.sort}
        onChange={(input) =>
          setForm((prev) => ({
            ...prev,
            sort: input.target.value,
          }))
        }
      />
      <label>کد</label>
      <input
        className="persianName"
        defaultValue={form?.code}
        onChange={(input) =>
          setForm((prev) => ({
            ...prev,
            code: input.target.value,
          }))
        }
      />
      {paramId && (
        <>
          <label>URL</label>
          <div className="rowReverse">
            <input
              className="persianName halfWidth"
              defaultValue={form?.slug}
              onChange={(input) =>
                setForm((prev) => ({
                  ...prev,
                  slug: input.target.value,
                }))
              }
            />
            <label>
              <a
                href={`${process.env.REACT_APP_CLIENT_URL}/product/${form?.slug}`}
                target="_blank"
              >{`${process.env.REACT_APP_CLIENT_URL}/product/`}</a>
            </label>
          </div>
        </>
      )}
      <label>وزن (گرم)</label>
      <input
        className="persianName"
        type="number"
        min={0}
        defaultValue={form?.weight}
        onChange={(input) =>
          setForm((prev) => ({
            ...prev,
            weight: input.target.value,
          }))
        }
      />
      <label>تگ ها</label>
      <Select
        options={tools.selectFormatter(tags, "id", "title")}
        value={tools.selectFormatter(
          tags.filter((e) => form?.tags?.includes(e.id.toString())),
          "id",
          "title",
        )}
        className="width100"
        isMulti={true}
        onChange={(selected) =>
          setForm((prev) => ({
            ...prev,
            tags: selected.map((e) => e.value.toString()),
          }))
        }
      />
      {/* <label>دسته بندی</label> */}
      {/* <Select options={tools.selectFormatter(categories, 'id', 'title', 'انتخاب کنید')} value={tools.selectFormatter(categories.filter(e => e.id == form.categoryId), 'id', 'title')} className="width100" */}
      {/*         onChange={(selected) => setForm(prev => ({ */}
      {/*           ...prev, */}
      {/*           categoryId: selected.value.toString() */}
      {/*         }))} */}
      {/* /> */}
      <label>برند</label>
      <Select
        options={tools.selectFormatter(brands, "id", "title", "انتخاب کنید")}
        value={tools.selectFormatter(
          brands.filter((e) => e.id == form.brandId),
          "id",
          "title",
        )}
        className="width100"
        onChange={(selected) =>
          setForm((prev) => ({
            ...prev,
            brandId: selected.value.toString(),
          }))
        }
      />
      {/*<label>ماشین</label>
      <Select
        options={tools.selectFormatter(cars, "id", "slug", "انتخاب کنید")}
        value={tools.selectFormatter(
          cars.filter((e) => e.id == form.carId),
          "id",
          "slug",
        )}
        className="width100"
        onChange={(selected) =>
          setForm((prev) => ({
            ...prev,
            carId: selected.value.toString(),
          }))
        }
      />*/}
      <label className="sideBarTitle">وضعیت</label>
      <Select
        options={[
          { value: 1, label: "فعال" },
          { value: 0, label: "غیر فعال" },
        ]}
        value={tools.selectFormatter(
          [
            { value: 1, label: "فعال" },
            { value: 0, label: "غیر فعال" },
          ].filter((e) => e.value == form?.status),
        )}
        className="width100"
        onChange={(selected) =>
          setForm((prev) => ({
            ...prev,
            status: selected.value,
          }))
        }
      />
      <label>توضیح کوتاه</label>
      <textarea
        className="ShortDiscription"
        defaultValue={form?.shortText}
        onChange={(input) =>
          setForm((prev) => ({
            ...prev,
            shortText: input.target.value,
          }))
        }
      />
      <label>توضیح بلند</label>
      {/* rich text: the storefront renders `longText` as HTML, so the editor
          hands back the same markup CKEditor produced */}
      <RichTextEditor
        value={form?.longText}
        onChange={(longText) => setForm((prev) => ({ ...prev, longText }))}
      />
      <label>پیش محصول</label>
      <input
        className="checkBox"
        type="checkbox"
        checked={form?.isPre}
        onChange={(input) =>
          setForm((prev) => ({
            ...prev,
            isPre: input.target.checked,
          }))
        }
      />
    </div>
  );
};

export default Basic;
